export enum PageType {
  HomePage = 1,
  AboutUs = 2,
  Contact = 3,
  Search = 4,
  EquipmentList = 5,
  EquipmentDetails = 6,
  Manufacturers = 7,
}
